module.exports = __webpack_public_path__ + "img/Download icon (2).37410c75.svg";